/* global tansa4ClientExtension */
import intl from 'react-intl-universal'

import CONSTANTS from '~/constants'

export default ['$scope', '$rootScope', '$http', 'toastr', tansaController]

function tansaController($scope, $rootScope, $http, toastr) {
  this.intl = intl

  // Tansa exspects to work with a global var
  global.tansa = { settings: {} }

  // catch settings are already loaded
  this.show = global.tansa.settings.licenseKey =
    (($rootScope.globalSettings || false).tansa || false).companyId || false

  // throbber conditional
  this.loading = false

  // catch broadcase
  $rootScope.$on(
    'SETTINGS_LOADED',
    function(i, data) {
      this.show = global.tansa.settings.licenseKey =
        (((data || false).data || false).tansa || false).companyId || false
    }.bind(this)
  )

  /* configuration */
  // required settings
  // // TODO: mike: auto generate
  global.tansa.settings.parentAppVersion = 'rc-2018.1'
  // Use user email or for debugging purposes, the ellipsis tansa account ( this is seperate from the support system )
  // Your Account Credentials are as follows:
  // Username required for login is : ellipsis@washpost.com
  // Password : rj3re6zm
  global.tansa.settings.tansaUserId =
    (($rootScope.globalSettings || false).tansa || false).globalId ||
    window.localStorage.getItem('arc.email') ||
    'ellipsis@washpost.com'
  // hardcoded in, supplyed by Tansa for only ellipsis
  global.tansa.settings.parentAppId = '1d824302-9618-4260-bead-f65cdb0aa07a'
  // tansa server base urls e.g "http://localhost:8080/tansaclient/"
  global.tansa.settings.baseUrl = `${window.location.protocol}//${window.location.host}${CONSTANTS.TRIDENT_ROUTE_COMPOSER_API}/v1/tansaclient/`
  global.tansa.settings.clientExtenstionJs = 'tansa4ClientExtensionSimple.js'

  /* send configuration */
  this.checkAndLoadMenuFromServer = function() {
    const fail = () => {
      this.loading = false
      toastr.error(intl.get('tansa.checkAndLoadMenuFromServer.error'))
    }

    this.loading = true
    const tansaLoaderScript = document.getElementById('tansaLoaderScript')
    if (!tansaLoaderScript) {
      const script = document.createElement('script')
      script.src = `${
        global.tansa.settings.baseUrl
      }initTansaLoader.js?${new Date().getTime()}`
      // check if file exsists
      $http({ method: 'GET', url: script.src }).then(() => {
        document.querySelector('head').appendChild(script)
      }, fail)
    } else {
      this.loading = false
      try {
        // this is defined in the nested script that tansa imports to the dom
        tansa4ClientExtension.initMenu()
      } catch (e) {
        console && console.error('Tansa error: ', e)
        fail()
      }
    }
  }
}
